import { BaseDto } from "@/shared/dtos/base-dto";

export class mantenimiento_permiso extends BaseDto {
  public nombre!: string;
  public permiso_read!: string;
  public permiso_write!: string;
  public permiso_update!: string;
  public permiso_delete!: string;

  public permiso_menu!: string;
  public permiso_global!: string;
}
